import { render } from "./ManageUserGroups.vue?vue&type=template&id=4c22b304"
import script from "./ManageUserGroups.vue?vue&type=script&lang=js"
export * from "./ManageUserGroups.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__